import React from 'react';
import PropTypes from 'prop-types';
import Panic from 'Errors/Panic';
import ViewBeside from './ViewBeside';
import ViewReplace from './ViewReplace';

const View = ({
  variant,
  ...rest
}) => {
  switch (variant) {
    case 'beside':
      return (
        <ViewBeside
          {...rest}
        />
      );
    case 'replace':
      return (
        <ViewReplace
          {...rest}
        />
      );
    default:
      throw new Panic('invalid-variant', 'Variant must be one of beside or replace', {
        variant,
      });
  }
};

View.defaultProps = {
  variant: 'replace',
};

View.propTypes = {
  variant: PropTypes.oneOf([
    'replace',
    'beside',
  ]),
};

export default View;
